import React from 'react'
import { twMerge } from 'tailwind-merge'

interface AuthRegularCardLayoutProps {
  title: string
  description?: string
  children: React.ReactNode
  className?: string
}

export const AuthRegularCardLayout = ({
  title,
  description,
  children,
  className,
}: AuthRegularCardLayoutProps) => {
  return (
    <div
      className={twMerge(
        'mx-auto my-16 max-w-[500px] rounded-lg bg-background-secondary p-10 text-center shadow-authShadow',
        className,
      )}
    >
      <h2 className="mb-4">{title}</h2>
      {description && <p className="text-sm text-text-tertiary">{description}</p>}
      {children}
    </div>
  )
}
